var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"breadcrumbs"},[_c('ul',{staticClass:"breadcrumbs__list"},[_c('li',{staticClass:"breadcrumbs__list--item"},[_c('a',{staticClass:"breadcrumbs__list--link",attrs:{"href":"/"}},[_vm._v("Главная")])]),_c('li',{staticClass:"breadcrumbs__list--item"},[_vm._v("Контакты")])])])
}]

export { render, staticRenderFns }